import { SmallClassCodeComboBoxComponent } from './small-class-code-combo-box.component';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';

/**
 * 小分類コードコンボボックスManageクラス
 *
 * @export SmallClassCodeComboBoxModel
 * @class SmallClassCodeComboBoxModel
 */
export class SmallClassCodeComboBoxModel {
  public smallClassList = [];

  public blank: boolean = <boolean>true;                                        // 先頭空白表示
  public component: SmallClassCodeComboBoxComponent;                            // コンボボックスインスタンス
  public completeUpdateFlg: boolean = <boolean>false;                           // コードリスト取得完了
  public setSmallClassCode: string = null;                                      // 初期設定コード値

  // Note: 以降のメンバ変数は現行で明示的な宣言無し or HTML5の移植で必要になったメンバ
  public isInitOrderCode: boolean = <boolean>false;                             // 受注コード初期化済フラグ
  public initAutoLoad: boolean = <boolean>true;                                 // 初期データ自動取得フラグ
  public setSelectedIndex: number = <number>-1;                                 // 初期設定インデックス


  /**
   * 小分類コードリストアップデート
   *
   * @param {*} serverData サーバから取得された<Data>タグ
   * @memberof SmallClassCodeComboBoxModel
   */
  public updateSmallClassList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      const ob = {
        ClassCode: '',
        LargeClassCode: '',
        MiddleClassCode: '',
        SmallClassCode: '',
        SmallClassName: '',
        SmallClassCodeName: ''
      };
      tempDataList.splice(index, 0, ob);
      index = 1;
    }

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
      tempDataList[index].SmallClassCodeName =
        tempDataList[index].SmallClassCode + ':' + tempDataList[index].SmallClassName;
    }

    this.smallClassList = tempDataList;

    this.completeUpdateFlg = true;
    this.component.updateSelectedSmallClassCode();
    this.component.updateSelectedIndex();
  }

}
